import React from "react";
import Navbar from "../Employee/Routes/Navbar";
import { Navigate } from "react-router-dom";
import { getUser } from "../../Utils/helper";
import DashboardContentShell from "./DashboardContentShell";

const EmployeeLayout = () => {
  let userAuth = getUser() ? getUser() || "" : null;
  return userAuth?.employee?.role === "employee" ? (
    <React.Fragment>
      <Navbar />
      <DashboardContentShell />
    </React.Fragment>
  ) : (
    <Navigate to={`/`} />
  );
};
export default EmployeeLayout;
